const comparePriceToParent = (includedProducts) => {
    if (includedProducts?.length) {
        return includedProducts.reduce((acc, curr) => {
            const { price_standard: standardPrice, quantity } = curr || {};
            acc += standardPrice * quantity;

            return acc;
        }, 0);
    }
    return null;
};

export default comparePriceToParent;
